import React, { FC } from 'react';
import { ResourceListSkeleton } from 'src/components/widgets/resourceList';
import {
    SkeletonBlock,
    SkeletonFooterBar,
    SkeletonPageHeader,
    SkeletonPageMenu,
    SkeletonPageMenuContentContainer,
    SkeletonPageMenuLayoutContainer,
    SkeletonPageShell,
    SkeletonRow,
    SkeletonStack,
    SkeletonSurface
} from 'src/components/widgets/skeleton';

export const PricingRulePageSkeleton: FC<{ embedded?: boolean }> = ({ embedded = false }) => (
    <SkeletonPageShell aria-hidden='true' $padding={embedded ? '24px' : '20px 0 92px'}>
        {!embedded && (
            <SkeletonPageHeader>
                <SkeletonStack $gap='8px' $flex='1'>
                    <SkeletonBlock $width='min(240px, 100%)' $height='26px' />
                    <SkeletonBlock $width='min(380px, 100%)' $height='13px' />
                </SkeletonStack>
                <SkeletonBlock $width='120px' $height='36px' $radius='6px' />
            </SkeletonPageHeader>
        )}
        <SkeletonPageMenuLayoutContainer>
            <SkeletonPageMenu itemWidths={['62px', '42px', '96px']} />
            <SkeletonPageMenuContentContainer>
                <SkeletonStack $gap='18px'>
                    {Array.from({ length: 3 }).map((_, index) => (
                        <SkeletonSurface key={index} $padding='24px'>
                            <SkeletonStack $gap='14px'>
                                <SkeletonBlock $width={index === 0 ? '120px' : '180px'} $height='20px' />
                                <SkeletonBlock $width='min(360px, 100%)' $height='13px' />
                                <SkeletonBlock $height={index === 1 ? '96px' : '40px'} $radius='6px' />
                                {index === 1 && (
                                    <SkeletonRow $gap='10px'>
                                        <SkeletonBlock $width='150px' $height='32px' $radius='16px' />
                                        <SkeletonBlock $width='180px' $height='32px' $radius='16px' />
                                    </SkeletonRow>
                                )}
                            </SkeletonStack>
                        </SkeletonSurface>
                    ))}
                </SkeletonStack>
            </SkeletonPageMenuContentContainer>
        </SkeletonPageMenuLayoutContainer>
        <SkeletonFooterBar $position={embedded ? 'static' : 'fixed'}>
            <SkeletonBlock $width='110px' $height='36px' $radius='6px' />
            <SkeletonBlock $width='88px' $height='36px' $radius='6px' />
        </SkeletonFooterBar>
    </SkeletonPageShell>
);

export const PricingRuleEmbeddedPageSkeleton: FC = () => <PricingRulePageSkeleton embedded />;

export const PricingRulesPageSkeleton: FC = () => (
    <SkeletonPageShell aria-hidden='true' $padding='20px 0 92px'>
        <SkeletonPageHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(190px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(360px, 100%)' $height='13px' />
            </SkeletonStack>
            <SkeletonBlock $width='112px' $height='36px' $radius='6px' />
        </SkeletonPageHeader>
        <ResourceListSkeleton tableColumns={['minmax(180px, 1fr)', '140px', '210px']} />
    </SkeletonPageShell>
);
